export const contentExtras = {
    excursion: {
        active: true,
        icon: 'attractions',
        link: 'ausfluege',
        travelTileTitle: 'Ausflüge buchen',
        title: 'Ausflug',
        description: {
            default: 'Auf ins Abenteuer! Entdecken Sie Ihren Urlaubsort von seiner aufregendsten Seite.',
        },
    },
    transfer: {
        active: true,
        icon: 'airport_shuttle',
        link: 'transfer',
        travelTileTitle: 'Transfer buchen',
        title: 'Transfer',
        titleAlreadyBooked: 'Transfer',
        description: {
            default: 'Gut organisiert unterwegs: Buchen Sie einen Transfer per Shuttle oder Privattransfer.',
            alreadyBooked: 'Sie haben bereits einen Transfer gebucht.',
        },
    },
    insurance: {
        active: false,
        icon: '',
        link: 'versicherung',
        travelTileTitle: 'Versicherung',
        title: 'Versicherung',
        description: {
            default: '',
        },
    },
    luggage: {
        active: false,
        icon: 'luggage',
        link: 'zusaetzliches-Gepaeck',
        title: 'Zusätzliches Gepäck',
        description: {
            default: '',
        },
    },
    railAndFly: {
        active: true,
        icon: 'train',
        link: 'zug-zum-flug',
        travelTileTitle: 'Rail&Fly buchen',
        title: 'Rail&Fly',
        titleAlreadyBooked: 'Rail&Fly',
        description: {
            default: 'Mit Rail&Fly fahren Sie deutschlandweit bequem mit dem Zug bis zum Flughafen (und zurück).',
            alreadyBooked: 'Sie haben bereits einen Zug zum Flug gebucht.',
        },
    },
    seatReservation: {
        active: true,
        icon: 'airline_seat_recline_normal',
        link: 'sitzplatzreservierung',
        travelTileTitle: 'Sitzplatzreservierung (Flug) hinzufügen',
        title: 'Sitzplatzreservierung (Flug)',
        description: {
            default: 'Buchen Sie Ihren Wunschsitzplatz mit extra viel Beinfreiheit für mehr Reisekomfort.',
            alreadyBooked: 'Alle Sitzplätze wurden erfolgreich gebucht.',
        },
    },
};
export default contentExtras;
